var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 21V3M14.5 14l2-2-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 3h3a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5h-3M10 3H8a5 5 0 0 0-5 5v8a5 5 0 0 0 5 5h2"
  }))));
};
export { SvgClose as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZmI0Y2QzM2Y5YzM5NzVlMzRjMGY3OWZjYmQ4NDE4MzIuc3ZnIjs=";